import { Capacitor } from "@capacitor/core";

export type KonstaTheme = "ios" | "material";

export const resolveKonstaTheme = (): KonstaTheme => {
  return Capacitor.getPlatform() === "ios" ? "ios" : "material";
};

export const shouldUseKonstaSafeAreas = (): boolean => {
  return Capacitor.isNativePlatform();
};
